/**
 * pcn-buy-now.js — "Comprar ahora" que PASA por el carrito.
 *
 * El botón dinámico de Shopify ({{ form | payment_button }}) crea el checkout
 * directo con ese único producto, sin tocar el carrito. Como el regalo por
 * compra lo agrega al carrito un script del theme (gift_with_purchase_sgd.js),
 * con ese botón el regalo nunca entra.
 *
 * Este botón ([data-pcn-buy-now], lo renderiza snippets/product-form.liquid
 * cuando el bloque tiene "Comprar ahora pasa por el carrito" activo):
 *   1) agrega el producto del formulario al carrito (variante, cantidad,
 *      propiedades, plan de suscripción: todo lo que lleve el form),
 *   2) sincroniza el regalo con la MISMA regla que gift_with_purchase_sgd.js
 *      (leyendo la sección mini_cart recién renderizada por el servidor),
 *   3) redirige a /checkout.
 * Si la sincronización del regalo falla, igual se va al checkout: nunca
 * bloquear una compra por el regalo.
 */
(function () {
  'use strict';

  if (window.__pcnBuyNow) return;
  window.__pcnBuyNow = true;

  var CHECKOUT = '/checkout';

  function avisar(msg) {
    try {
      if (window.T4SThemeSP && typeof window.T4SThemeSP.Notices === 'function') window.T4SThemeSP.Notices(msg);
    } catch (e) { /* aviso cosmético */ }
  }

  function leerConfigRegalo() {
    var c = document.getElementById('gift-with-purchase-config');
    if (!c) return null;
    var cfg = {
      triggerId: String(c.getAttribute('data-purchase-id') || '').trim(),
      giftId: String(c.getAttribute('data-gift-id') || '').trim(),
      goal: parseInt(c.getAttribute('data-purchase-goal'), 10) || 0,
      removeGift: c.getAttribute('data-remove-gift') === 'true'
    };
    return (cfg.giftId && cfg.goal > 0) ? cfg : null;
  }

  // Misma regla que assets/gift_with_purchase_sgd.js (cantidad por kit,
  // producto disparador opcional, +1 si el regalo es el mismo producto),
  // pero leyendo el carrito real desde la sección mini_cart del servidor.
  function sincronizarRegalo() {
    var cfg = leerConfigRegalo();
    if (!cfg) return Promise.resolve();
    return fetch('/?section_id=mini_cart', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rows = doc.querySelectorAll('[data-item-kit-qty][data-variant-id]');
        var triggerQty = 0;
        var giftInCart = false;
        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          var variantId = row.getAttribute('data-variant-id') || '';
          var kitQty = parseInt(row.getAttribute('data-item-kit-qty'), 10) || 1;
          var input = row.querySelector('input[name="updates[]"], input[type="number"]');
          var qty = input ? (parseInt(input.value, 10) || 0) : 0;
          if (cfg.triggerId) {
            if (variantId === cfg.triggerId) triggerQty += kitQty * qty;
          } else if (variantId !== cfg.giftId) {
            triggerQty += kitQty * qty;
          }
          if (variantId === cfg.giftId) giftInCart = true;
        }
        var requerido = cfg.triggerId === cfg.giftId ? cfg.goal + 1 : cfg.goal;
        if (triggerQty >= requerido && !giftInCart) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: cfg.giftId, quantity: 1, properties: { _auto_gift: 'true' } })
          });
        }
        if (cfg.removeGift && triggerQty < requerido && giftInCart) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: cfg.giftId, quantity: 0 })
          });
        }
      })
      .catch(function () { /* el regalo nunca bloquea la compra */ });
  }

  function agregarDesdeForm(form) {
    var datos = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      body: datos,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pcn-buy-now]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var form = btn.closest('form');
    if (!form) return;

    btn.disabled = true;
    btn.style.opacity = '.65';
    btn.style.cursor = 'progress';

    agregarDesdeForm(form)
      .then(sincronizarRegalo)
      .then(function () { window.location.href = CHECKOUT; })
      .catch(function (err) {
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.cursor = '';
        avisar((err && (err.description || err.message)) || 'No se pudo agregar el producto. Intenta de nuevo.');
      });
  });
})();
